<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up deck-settings">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Deck Settings</h3>

            <label class="deck-settings-label" for="deck-complete-action">When a card is checked off</label>
            <select id="deck-complete-action" v-model="action">
                <option value="prompt">Ask whether to move it</option>
                <option value="none">Do nothing</option>
                <option value="move">Move it to a column</option>
            </select>
            <template v-if="action == 'move'">
                <label class="deck-settings-label" for="deck-complete-column">Column</label>
                <select id="deck-complete-column" v-model="column">
                    <option value="" disabled>Pick a column</option>
                    <option v-for="name in columns" :key="name" :value="name">{{ name }}</option>
                </select>
            </template>

            <input :class="disableButton ? 'disable-button' : ''" type="submit" value="Save" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

// A deck's settings (its 3-dot menu > Settings; API companyboards.ts POST /settings). For now, what checking a card off
// does: ask whether to move it (the default), nothing, or move it to a chosen column. slug: the deck; columns: its column
// names; completeAction / completeColumn: as saved. Emits saved({ completeAction, completeColumn }).
export default defineComponent({
    name: 'DeckSettingsModal',
    props: {
        slug: { type: String, required: true },
        columns: { type: Array as () => string[], required: true },
        completeAction: { type: String, default: 'prompt' },
        completeColumn: { type: String, default: '' }
    },
    emits: [ 'close', 'saved' ],
    data() {
        // A move to a column that's since been removed reads as the default, as it behaves
        const columnGone = this.completeAction == 'move' && !this.columns.includes(this.completeColumn);
        return {
            action: columnGone ? 'prompt' : (this.completeAction || 'prompt'),
            column: columnGone ? '' : (this.completeColumn || this.columns[this.columns.length - 1] || ''),
            disableButton: false
        }
    },
    methods: {
        async submit() {
            if(this.disableButton) {
                return;
            }
            if(this.action == 'move' && !this.column) {
                alert('Pick a column to move checked-off cards to.');
                return;
            }
            this.disableButton = true;
            const settings = { completeAction: this.action, completeColumn: this.action == 'move' ? this.column : '' };
            await axios.post(`${this.$store.state.apiUrl}/api/companyboards/settings`, { slug: this.slug, ...settings })
                .then(() => {
                    this.$emit('saved', settings);
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error');
                })
            this.disableButton = false;
        }
    }
});
</script>

<style scoped>
.deck-settings-label { display: block; font-weight: 600; margin: 0 0 6px; }
.deck-settings select { margin-bottom: 15px; }
</style>
